.user-info {
    font-size: 11px;
    color: #495057;
}

.last-sent {
    font-size: 10px;
    color: #28a745;
    padding: 3px 8px;
    background: #d4edda;
    border-radius: 3px;
}

.email-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.form-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.label {
    font-size: 11px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
}

.input,
.select,
.textarea,
.textarea-signature {
    padding: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    background: white;
}

.input:focus,
.select:focus,
.textarea:focus,
.textarea-signature:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
}

.select {
    cursor: pointer;
}

.textarea {
    resize: vertical;
    min-height: 120px;
    line-height: 1.5;
}

.textarea-signature {
    resize: vertical;
    min-height: 80px;
    line-height: 1.4;
    font-family: 'SF Mono', Monaco, 'Consolas', monospace;
    font-size: 12px;
    background: #f8f9fa;
}

.form-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 8px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #495057;
    cursor: pointer;
    margin-right: auto;
}

.send-button,
.randomize-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s ease;
}

.send-button {
    background: #007bff;
    color: white;
}

.send-button:hover:not(:disabled) {
    background: #0056b3;
}

.send-button:disabled {
    background: #6c757d;
    cursor: not-allowed;
}

.randomize-button {
    background: #e9ecef;
    color: #495057;
}

.randomize-button:hover {
    background: #dee2e6;
}

.status-error,
.status-success {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
}

.status-error {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.status-success {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.preview {
    margin-top: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
}

.preview-header {
    padding: 8px 12px;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
}

.preview-content {
    padding: 12px;
    background: white;
}

.preview-meta {
    font-size: 12px;
    color: #495057;
    margin-bottom: 4px;
}

.preview-meta strong {
    color: #212529;
}

.preview-divider {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 12px 0;
}

.preview-body {
    font-size: 13px;
    line-height: 1.6;
    color: #212529;
    white-space: pre-wrap;
}
